export default "__VITE_ASSET__6dbcb1ae__"